import { Box } from '@mui/material';

const GridBox = ({ children }) => (
    <Box
        display="grid"
        gap={2}
        gridTemplateColumns="repeat(auto-fill, minmax(196px, 1fr))"
    >
        {children}
    </Box>
);

export default GridBox;
